// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"select_inputContainer__kF05G"};